"use strict";

exports.__esModule = true;
exports.applyTicketTypeFilters = applyTicketTypeFilters;
/**
 * Filers the given list down by enabled filters and search term
 */
function applyTicketTypeFilters(ticketTypes, enabled, filterValue) {
  return ticketTypes.filter(function (item) {
    return item.enabled === enabled && item.value.match(new RegExp(filterValue, "gi"));
  });
}